<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="XML名称">
            <a-input v-model="searchForm.name" allowClear placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="8" :xl="8">
          <a-form-item label="XML名称（拼音）">
            <a-input v-model="searchForm.pinyin" allowClear placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="选择业务线">
            <a-select
              v-model="searchForm.line_id"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              style="width: 100%"
            >
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" class="btn-color-success" @click="handleAdd">新增XML</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" class="btn-color-warning" @click="handleClear">清空</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table
      bordered
      size="small"
      row-key="id"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :pagination="pagination"
      style="margin-top: 20px"
      @change="handleTableChange"
    >
      <template slot="org" slot-scope="text">
        <a-tag color="blue">{{ text }}</a-tag>
      </template>
      <template slot="pinyin" slot-scope="text">
        {{ text + '.xml' }}
      </template>

      <template slot="operator" slot-scope="text, record">
        <div class="flex-sa-ac">
          <a-button size="small" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" ghost type="danger" @click="handleTableCommand('delete', record)">删除</a-button>
          <a-button size="small" ghost type="primary" @click="lookArticle(record)">查看详情</a-button>
        </div>
      </template>
    </a-table>

    <!-- 添加公司 -->
    <AddWebsite
      v-model="visible"
      :isEdit="isEdit"
      :params="waitItem"
      :platformList="platformList"
      :classifyList="classifyList"
      @handleOver="getList"
    />
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm, columns, form } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import AddWebsite from './components/AddWebsite'
import api from '@/api/'

export default {
  components: { AddWebsite },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      classifyList: [],
      searchForm: { ...searchForm },
    })

    onMounted(async () => {
      await methods.getPlatform()
      await methods.getArticleClassify()
      methods.getList()
    })

    const methods = {
      search() {
        _this.pagination.current = 1
        this.getList()
      },

      async getList() {
        _this.loading = true
        state.searchForm.end_time = state.times[1]
        const res = await api.websiteMapList({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize,
        })
        const { websiteMaps, pagination } = res.data
        _this.data = websiteMaps
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },

      // 获取文章分类
      async getArticleClassify() {
        const res = await api.listClassify()
        state.classifyList = res.data.articleType
      },

      async inputDebounce(sort, data) {
        const res = await api.updateLink(data)
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
        }
      },
      // 刷新视图
      refreshView() {
        this.handleClear()
      },
      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
      // 查看文章
      lookArticle(item) {
        _this.$router.push(`/websiteAdmin/lookArticle?website_map_id=${item.id}&name=${item.name}`)
      },
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...methods,
    }
  },
}
</script>
